import { styled } from "styled-components";
import Header from "./Header";
import Interface from "./Interface";

const Root = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

function App({ store }) {
  return (
    <Root>
      <Header store={ store } />
      <Interface store={ store } />
    </Root>
  );
}

export default App;
